import {api} from '../components/Base/App';

export default {
    confirmEmail(confirmationCode) {
        return api({
            method: 'get',
            url: `/rest/api/jwt/email/confirmation/${confirmationCode}`
        });
    },

    restoreEmailPasswordFirst(email) {
        return api({
            method: 'post',
            url: `/rest/api/jwt/email/restore-first`,
            data: {
                email
            }
        });
    },

    restoreEmailPasswordSecond(key,password) {
        return api({
            method: 'post',
            url: `/rest/api/jwt/email/restore-second?key=${key}`,
            data: {
                password
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/JwtController.js